import currentUserService from "./currentUserService";

const $inject = [
  '$window',
  '$q',
  '$http',
  '$cookies',
  '$httpParamSerializer',
  'moment',
  'settingsService',
  'userInfoService',
  'userProfileService',
  'userDebtorService',
  'apiService',
  'currentUserService',
  'travellersService',
  'APP_CONFIG'
];

const authService = function (
                              $window,
                              $q,
                              $http,
                              $cookies,
                              $httpParamSerializer,
                              moment,
                              settingsService,
                              userInfoService,
                              userProfileService,
                              userDebtorService,
                              apiService,
                              currentUserService,
                              travellersService,
                              APP_CONFIG) {
  let service = {};
  service.getUsername = getUsername;
  service.login = login;
  service.authenticate = authenticate;
  service.logout = logout;
  service.refresh = refresh;
  service.reset = reset;
  service.forgot = forgot;
  service.storeAuth = storeAuth;
  service.getOauth = getOauth;
  service.clearOauth = clearOauth;
  service.getAccessToken = getAccessToken;
  service.getRefreshToken = getRefreshToken;
  service.isAuthenticated = isAuthenticated;

  function getUsername() {
    return service.getOauth().username;
  }

  function login(username, password) {
    return authenticate(username, password).then(() => {
      return userInfoService.getInfo().catch(clearOauth);
    })
  }

  function authenticate(username, password) {
    let data = {
      client_id: APP_CONFIG.client.id,
      client_secret: APP_CONFIG.client.secret,
      grant_type: 'password',
      username: username,
      password: password
    };

    let req = {
      isPublic: true,
      withCredentials: true,
      method: 'POST',
      url: APP_CONFIG.api.token,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      data: $httpParamSerializer(data)
    };


    return $http(req).then(function (res) {
      let data = res.data;
      let results = [];
      results.headers = data.headers();
      $cookies.put('.AspNet.Application', results.headers.lightningbook_web_cookie);

      storeAuth(data.data);
    });
  }

  function logout() {
    let deferred = $q.defer();

    // TODO Should be more organised than this, possible service that all these methods are added to

    clearOauth();
    currentUserService.clear();
    settingsService.clear();
    userProfileService.clear();
    userDebtorService.clear();
    travellersService.init();

    $window.mixpanel.reset();

    deferred.resolve();

    return deferred.promise;
  }

  function refresh(accessToken) {
    let data = {
      client_id: APP_CONFIG.client.id,
      client_secret: APP_CONFIG.client.secret,
      grant_type: 'refresh_token',
      refresh_token: accessToken
    };

    let req = {
      method: 'POST',
      url: APP_CONFIG.api.token,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      data: $httpParamSerializer(data)
    };

    return $http(req).then(function (res) {
      let data = res.data;
      let oauth = {};
      oauth.refresh_token = data.refresh_token;
      oauth.access_token = data.access_token;

      localStorage.setItem('oauth', JSON.stringify(oauth));
    });
  }


  function forgot(email) {
    let req = {
      isPublic: true,
      method: 'POST',
      url: apiService.getUrl('forgotPassword', { email }),
      headers: {
        'Content-type': 'application/json'
      }
    };

    return $http(req);
  }

  function reset(token, credentials) {
    let req = {
      isPublic: true,
      method: 'PUT',
      url: apiService.getUrl('resetPassword', { token }),
      headers: {
        'Content-type': 'application/json'
      },
      data: credentials
    };

    return $http(req);
  }

  function getOauth() {
    let accessToken = $cookies.get('LIGHTNINGBOOK_API_ACCESSTOKEN');

    if (accessToken) {
      let oauthData = {access_token: accessToken, expires_at: moment().add(14, 'days').format('x')};
      localStorage.setItem('oauth', JSON.stringify(oauthData));
    }

    return JSON.parse(localStorage.getItem('oauth'));
  }

  function storeAuth(auth) {
    auth.expires_at = moment().add(auth.expires_in, 's').format('x');
    localStorage.setItem('oauth', JSON.stringify(auth));
    return getOauth();
  }

  function clearOauth() {
    $cookies.remove('LIGHTNINGBOOK_API_ACCESSTOKEN');
    $cookies.remove('.AspNet.Application');

    const localStorageKeys = Object.keys(localStorage);
    const auth0Namespace = 'com.auth0.auth';

    localStorageKeys.forEach((key) => {
      if (key.includes(auth0Namespace)) {
        localStorage.removeItem(key);
      }
    });

    return localStorage.removeItem('oauth');
  }

  function getAccessToken() {
    let oauth = service.getOauth();

    return oauth ? oauth.access_token : '';
  }

  function getRefreshToken() {
    let oauth = service.getOauth();

    return oauth ? oauth.refresh_token : '';
  }

  function isAuthenticated() {
    let oauth = service.getOauth();

    return oauth && oauth.expires_at && oauth.expires_at > Date.now();
  }

  return service;
};

authService.$inject = $inject;

export default authService;



// WEBPACK FOOTER //
// ./src/services/authService.js